import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, Fragment as _Fragment, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3a64e12c"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "report" }, null, -1))
const _hoisted_2 = { class: "logo" }
const _hoisted_3 = { class: "swapBox" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "topBox" }, "智慧锦囊", -1))
const _hoisted_5 = { class: "topBoxRight" }
const _hoisted_6 = { class: "bakBox" }
const _hoisted_7 = { class: "reportText" }
const _hoisted_8 = { class: "boxTail" }
const _hoisted_9 = { class: "leftright" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("ul", null, [
  /*#__PURE__*/_createElementVNode("li", null, [
    /*#__PURE__*/_createElementVNode("div", { class: "yanjiu" }, [
      /*#__PURE__*/_createElementVNode("div", null, " AR的诊断应根据患者典型的过敏病史、临床表现以及与其一致的过敏原检测结果而作出，同时应注意与其它鼻炎的鉴别 "),
      /*#__PURE__*/_createElementVNode("div", null, [
        /*#__PURE__*/_createElementVNode("div", { class: "three" })
      ])
    ])
  ])
], -1))
const _hoisted_11 = { class: "reportText" }
const _hoisted_12 = { class: "boxTail" }
const _hoisted_13 = { class: "leftright" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("ul", null, [
  /*#__PURE__*/_createElementVNode("li", null, [
    /*#__PURE__*/_createElementVNode("div", { class: "yanjiu" }, [
      /*#__PURE__*/_createElementVNode("div", null, " 与第一代鼻用激素相比，第二代鼻用激素具有高亲脂性、与受体结合力强、抗炎活性更强、生物利用度低等特点 "),
      /*#__PURE__*/_createElementVNode("div", null, [
        /*#__PURE__*/_createElementVNode("div", { class: "three" })
      ])
    ])
  ])
], -1))
const _hoisted_15 = { class: "reportText" }
const _hoisted_16 = { class: "boxTail" }
const _hoisted_17 = { class: "leftright" }
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("ul", null, [
  /*#__PURE__*/_createElementVNode("li", null, [
    /*#__PURE__*/_createElementVNode("div", { class: "yanjiu" }, [
      /*#__PURE__*/_createElementVNode("div", null, " 辅舒良作为二代鼻用激素，是指南推荐用于治疗AR的一线用药，可显著改善患者症状，同时安全耐受 "),
      /*#__PURE__*/_createElementVNode("div", null, [
        /*#__PURE__*/_createElementVNode("div", { class: "three" })
      ])
    ])
  ])
], -1))
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "lastText" }, [
  /*#__PURE__*/_createTextVNode(" 这场探案，"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" 由你谱写结局！ ")
], -1))
const _hoisted_20 = { class: "pingzi" }
const _hoisted_21 = { class: "fdjbottom" }
const _hoisted_22 = { class: "backfirst" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_van_image = _resolveComponent("van-image")!
  const _component_medical = _resolveComponent("medical")!
  const _component_van_popup = _resolveComponent("van-popup")!
  const _component_toNav = _resolveComponent("toNav")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _hoisted_1,
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_van_image, {
        src: require('../assets/logo.png')
      }, null, 8, ["src"])
    ]),
    _createElementVNode("div", _hoisted_3, [
      _hoisted_4,
      _createElementVNode("div", _hoisted_5, [
        _createVNode(_component_van_image, {
          class: "rightImg",
          width: "2.4667rem",
          height: "3.08rem",
          src: require('../assets/dui.png')
        }, null, 8, ["src"])
      ]),
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("div", _hoisted_8, [
            _createElementVNode("div", _hoisted_9, [
              _createVNode(_component_van_image, {
                class: "rightImg",
                width: ".6667rem",
                height: ".6667rem",
                src: require('../assets/duigou.png')
              }, null, 8, ["src"])
            ]),
            _hoisted_10
          ])
        ]),
        _createElementVNode("div", _hoisted_11, [
          _createElementVNode("div", _hoisted_12, [
            _createElementVNode("div", _hoisted_13, [
              _createVNode(_component_van_image, {
                class: "rightImg",
                width: ".6667rem",
                height: ".6667rem",
                src: require('../assets/duigou.png')
              }, null, 8, ["src"])
            ]),
            _hoisted_14
          ])
        ]),
        _createElementVNode("div", _hoisted_15, [
          _createElementVNode("div", _hoisted_16, [
            _createElementVNode("div", _hoisted_17, [
              _createVNode(_component_van_image, {
                class: "rightImg",
                width: ".6667rem",
                height: ".6667rem",
                src: require('../assets/duigou.png')
              }, null, 8, ["src"])
            ]),
            _hoisted_18
          ])
        ]),
        _hoisted_19,
        _createElementVNode("div", _hoisted_20, [
          _createVNode(_component_van_image, {
            class: "finger",
            width: "2.1467rem",
            height: "2.6933rem",
            src: require('../assets/pingzi.png')
          }, null, 8, ["src"])
        ]),
        _createElementVNode("div", _hoisted_21, [
          _createVNode(_component_van_image, {
            class: "finger",
            width: "6.8267rem",
            height: "1.8133rem",
            src: require('../assets/fdj.png')
          }, null, 8, ["src"])
        ])
      ]),
      _createElementVNode("div", _hoisted_22, [
        _createVNode(_component_van_image, {
          onClick: $options.backfirst,
          width: "3.5467rem",
          height: ".96rem",
          src: require('../assets/backfirst.png')
        }, null, 8, ["onClick", "src"])
      ])
    ]),
    _createVNode(_component_van_popup, {
      show: $data.show,
      "onUpdate:show": _cache[0] || (_cache[0] = ($event: any) => (($data.show) = $event))
    }, {
      default: _withCtx(() => [
        ($data.flag)
          ? (_openBlock(), _createBlock(_component_medical, {
              key: 0,
              onOnChanged: $options.updateChanged,
              postaimqus: $data.postaimqus
            }, null, 8, ["onOnChanged", "postaimqus"]))
          : _createCommentVNode("", true),
        (!$data.flag)
          ? (_openBlock(), _createBlock(_component_medical, {
              key: 1,
              onOnChanged: $options.updateChanged,
              postaimqus: $data.postaimqus
            }, null, 8, ["onOnChanged", "postaimqus"]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["show"]),
    _createVNode(_component_toNav, { menu: 5 })
  ], 64))
}